<script>
export default {
    name: 'MemberIcon'
};
</script>

<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#F3F3F3" />
        <path
            d="M15.7505 16.0004C17.7759 16.0004 19.4174 14.3586 19.4174 12.3335C19.4174 10.3084 17.7759 8.66663 15.7505 8.66663C13.7252 8.66663 12.0837 10.3084 12.0837 12.3335C12.0837 14.3586 13.7252 16.0004 15.7505 16.0004ZM15.7505 9.58335C17.2671 9.58335 18.5007 10.8169 18.5007 12.3335C18.5007 13.8498 17.2671 15.0837 15.7505 15.0837C14.2339 15.0837 13.0004 13.849 13.0004 12.3335C13.0004 10.8169 14.2351 9.58335 15.7505 9.58335ZM17.203 17.3755H14.2981C11.5568 17.3755 9.3335 19.5985 9.3335 22.3401C9.3335 22.8884 9.77811 23.3333 10.3264 23.3333H21.1752C21.7235 23.3342 22.1676 22.8901 22.1676 22.3401C22.1676 19.5985 19.9445 17.3755 17.203 17.3755ZM21.1735 22.4174H10.3264C10.2846 22.4174 10.2502 22.3831 10.2502 22.3401C10.2502 20.1084 12.0665 18.2922 14.2981 18.2922H17.2001C19.4346 18.2922 21.2509 20.1084 21.2509 22.3401C21.2509 22.3831 21.2165 22.4174 21.1735 22.4174Z"
            fill="#962C16"
        />
        <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#EBEBEB" />
    </svg>
</template>
